const TRADES = [
  "Residential Cleaning", "Commercial Cleaning", "Window Cleaning", "Pressure Washing",
  "Handyman Services", "Maintenance", "Mobile Detailing", "Landscaping",
  "Painting", "Junk Removal",
];

export default function TradesMarquee() {
  const items = [...TRADES, ...TRADES];
  return (
    <div
      data-testid="trades-marquee"
      className="bg-safety overflow-hidden border-y border-navy/20 py-4 relative"
      aria-label="Trades we serve"
    >
      <div className="animate-marquee-slow flex whitespace-nowrap w-max">
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-extrabold uppercase tracking-tight text-navy text-lg sm:text-xl px-6">
              {t}
            </span>
            <span className="w-2 h-2 bg-navy rotate-45" />
          </span>
        ))}
      </div>
    </div>
  );
}
